
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IuC5gOC4peC4t+C4reC4geC4m+C4o+C4sOC5gOC4oOC4l+C4m+C4o+C4sOC4geC4suC4qOC4h+C4suC4mSJ9!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IuC5gOC4peC4t+C4reC4geC4m+C4o+C4sOC5gOC4oOC4l+C4m+C4o+C4sOC4geC4suC4qOC4h+C4suC4mSJ9!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlBpbGloIGplbmlzIGlrbGFuIn0=!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlBpbGloIGplbmlzIGlrbGFuIn0=!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlNlbGVjdCBhbiBhZCB0eXBlIn0=!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IuC5gOC4peC4t+C4reC4geC4m+C4o+C4sOC5gOC4oOC4l+C4m+C4o+C4sOC4geC4suC4qOC4h+C4suC4mSJ9!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IuC5gOC4peC4t+C4reC4geC4m+C4o+C4sOC5gOC4oOC4l+C4m+C4o+C4sOC4geC4suC4qOC4h+C4suC4mSJ9!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlBpbGloIGplbmlzIGlrbGFuIn0=!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlBpbGloIGplbmlzIGlrbGFuIn0=!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlvFoOG6veG6veG6vcaa4bq94bq94bq9w6fhua8gxIPEg8SD4LiB4Li14LmJIMSDxIPEg8aMIOG5r8O9w73Dvcal4bq94bq94bq9XSJ9!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJTZWxlY3QgYW4gYWQgdHlwZSI6IlvFoOG6veG6veG6vcaa4bq94bq94bq9w6fhua8gxIPEg8SD4LiB4Li14LmJIMSDxIPEg8aMIOG5r8O9w73Dvcal4bq94bq94bq9XSJ9!"
        )
      )
      });
  
      export { translations as default };
    